// eslint-disable-next-line import/no-extraneous-dependencies
import i18n from 'i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { initReactI18next } from 'react-i18next';
import content from './locales/unsubscribe_email_content.json'
// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .init({
    debug: true,
    resources: {
      content: {
        translation: content,
      }
    },
    lng: 'content'
  });

export default i18n;
